// @flow

const ELO_K = 0.1;

// TODO: add to UI
const RATING_RANGE = Infinity;
const MAX_AGE = Infinity * 365 * 86400 * 1000;

function logL(advantage, winData) {
  let result = 0;
  for (let [win, ratingDifference] of winData) {
    const sign = (-1)**(win + 1);
    result -= Math.log(1 + Math.exp(sign * (-ratingDifference - advantage)));
  }
  return result;
}

// TODO: move to separate module
// TODO: maybe use newton method
function calculateAdvantage(winData) {
  let allWon = true, allLost = true;
  for (let [win] of winData) {
    allWon = allWon && win;
    allLost = allLost && !win;
  }
  if (allWon || allLost) {
    return {mean: allWon ? Infinity : -Infinity, error: Infinity};
  }
  const logL0 = logL(0, winData);
  let start = -1, end = 1;
  while (logL(start, winData) > logL0) {
    start *= 2;
  }
  while (logL(end, winData) > logL0) {
    end *= 2;
  }
  while (end - start > 0.001) {
    const a = start + (end - start) / 3;
    const b = start + 2 * (end - start) / 3;
    if (logL(a, winData) > logL(b, winData)) {
      end = b;
    } else {
      start = a;
    }
  }
  // TODO: refactor
  const logLStart = logL(start, winData);
  const secondDeriv =
    ((logL(start + 0.001, winData) - logLStart) / 0.001 -
    (logLStart - logL(start - 0.001, winData)) / 0.001) / 0.001;
  return {mean: start, error: Math.sqrt(1 / (-secondDeriv))};
}

// TODO: move rating stuff to a separate package
// TODO: rotate to canonical orientation here instead?
export function gamesWithRatings(size: number, games) {
  const ratings: Map<string, number> = new Map();
  const result = [];
  for (let game of games) {
    if (size === game.size) {
      result.push({game, ratings: [0, 0]});
    }
  }
  for (let i = 0; i < 2 * result.length; i++) {
    const entry = result[i >= result.length ? i - result.length : result.length - 1 - i];
    for (let j = 0; j < 2; j++) {
      const player = entry.game.players[j];
      let previousRating = ratings.get(player);
      if (previousRating == null) {
        previousRating = 0;
        ratings.set(player, 0);
      }
      entry.ratings[j] = previousRating;
    }
    const winningPlayer = entry.game.winner;
    const adjustment = ELO_K / (1 + Math.exp((-1)**winningPlayer * (entry.ratings[0] - entry.ratings[1])));
    for (let j = 0; j < 2; j++) {
      const newRating = entry.ratings[j] + (-1)**(winningPlayer + j) * adjustment;
      ratings.set(entry.game.players[j], newRating);
    }
  }
  return result;
}

// TODO: support transpositions
// TODO: better name
export function splitByMove(gamesWithRatings, moves): Map<string, *> {
  const time = Date.now();
  const moveIndex = moves.length;
  let maxRating = -Infinity;
  for (let entry of gamesWithRatings) {
    // TODO: maybe limit this based on time range
    maxRating = Math.max(maxRating, entry.ratings[0], entry.ratings[1]);
  }
  const minRating = maxRating - RATING_RANGE * Math.log(10) / 400;
  const gamesByMove = new Map();
  for (let entry of gamesWithRatings) {
    if (moveIndex > entry.game.moves.length ||
        time - Date.parse(entry.game.time) > MAX_AGE ||
        // TODO: consider not excluding the game if one player's rating is lower, but only their moves
        Math.min(entry.ratings[0], entry.ratings[1]) < minRating) {
      continue;
    }
    let match = true;
    for (let i = 0; i < moves.length; i++) {
      if (moves[i] !== entry.game.moves[i]) {
        match = false;
        break;
      }
    }
    if (!match) {
      continue;
    }
    const move = moveIndex < entry.game.moves.length ? entry.game.moves[moveIndex] : null;
    let gamesForMove = gamesByMove.get(move);
    if (gamesForMove == null) {
      gamesForMove = [];
      gamesByMove.set(move, gamesForMove);
    }
    gamesForMove.push(entry);
  }
  const result = new Map();
  for (let [move, games] of gamesByMove) {
    let count = 0;
    const winData = [];
    for (let entry of games) {
      count += 1;
      // The player who ultimately got that stone, regardless of whether they
      // originally played it or swapped it
      const movePlayer = entry.game.swapped ^ (moveIndex & 1);
      winData.push([movePlayer === entry.game.winner, entry.ratings[movePlayer] - entry.ratings[1 ^ movePlayer]]);
    }
    if (count > 0) {
      result.set(move, {count, advantage: calculateAdvantage(winData)});
    }
  }
  return result;
}



// WEBPACK FOOTER //
// ./src/processGames.js